<template>
  <div class="information-preview">
    <div
      v-for="item in $$FormData.information"
      :key="item.id"
      class="information-item"
      :class="[$$FormData.show_type]"
    >
      <img :src="item.cover_image" class="information-cover" alt=""/>
      <div class="information-info">
        <div class="information-title ellipsis-2">
          {{ item.title }}
        </div>
        <div class="gg-btn solid">查看详情</div>
      </div>
    </div>
    <div v-if="!$$FormData.information.length" class="empty">
      请选择书香资讯
    </div>
  </div>
</template>

<script>
export default {
  name: 'BookInformationPreview'
}
</script>

<style scoped lang="scss">
.information-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  .information-item {
    display: flex;
    justify-content: space-between;
    gap: 11px;
    width: calc(100% - 16px);
    overflow: hidden;
    padding: 14px 10px;
    background-color: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    .information-cover {
      width: 120px;
      height: 120px;
      border-radius: 5px;
      flex-shrink: 0;
      object-fit: cover;
    }
    .information-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .information-title {
        color: #3C4353;
        font-size: 16px;
        font-weight: bold;
        line-height: 23px;
        padding-right: 12px;
      }
      .gg-btn {
        align-self: flex-end;
        width: 70px;
        height: 18px;
        font-weight: normal;
        font-size: 12px;
        line-height: 12px;
        flex-shrink: 0;
      }
    }
    &.banner {
      flex-direction: column;
      gap: 10px;
      padding: 14px 11px;
      .information-cover {
        width: 100%;
        height: 160px;
        border-radius: 10px;
        object-fit: cover;
      }
      .information-info {
        flex-direction: row;
        gap: 28px;
      }
    }
  }
}
.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999999;
  width: 100%;
  height: 75px;
}
</style>